<template>
  <form class="flex items-start justify-around" @submit.prevent="update()">
    <p class="font-bold mt-4">Total Run Length</p>
    <feet-meters-input :value="form.length" :step-size="parseFloat(run.step_size)" :errors="form.errors.length" :max="50" @input="form.length = $event" />
    <loading-button :loading="form.processing" class="h-12 px-4 text-center text-white border border-gray-400 00 bg-blue-800" type="submit">Reload</loading-button>
  </form>
</template>

<script>
import LoadingButton from '@/Shared/LoadingButton'
import FeetMetersInput from '@/Shared/FeetMetersInput'

export default {
  components: {
    LoadingButton,
    FeetMetersInput,
  },
  props: {
    run     : Object,
  },
  remember: 'form',
  emits: [
    'processing',
  ],
  data() {
    return {
      form : this.$inertia.form({
        length: parseFloat(this.run.length),
      }),
    }
  },
  watch:{
    run ({ length }) {
      this.form.length = parseFloat(length)
    },
  },
  methods: {
    update() {
      this.form.put(`/runs/${this.run.id}`, {
        preserveState: true,
        onBefore: () => { this.$emit('processing', false) },
        onFinish: () => {this.$emit('processing', true)},
      })
    },
  },
}
</script>
